import gql from 'graphql-tag';

export const all = gql`{
    commodityGroups {
        id
        name
    }
}`;


export const get = gql`query getCommodityGroup($id: ID!) {
    commodityGroup(id: $id){
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/commodityGroup.js